import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as echarts from 'echarts';
import { formatTimeToStr, GetDateStr } from '@/utils/date';
import { showPayLineData } from '@/api/payment';
export default {
  name: 'PaymentLineChart',
  data: function data() {
    return {
      lineName: [this.$t('PaymentTrends.PullupToday'), this.$t('PaymentTrends.SuccessfulToday'), this.$t('PaymentTrends.PullupYesterday'), this.$t('PaymentTrends.SuccessfulYesterday'), this.$t('PaymentTrends.PullupLastWeek'), this.$t('PaymentTrends.SuccessfulLastWeek')],
      lineColor: ['#000000', '#660099', '#0000CC', '#6A7985', '#FF6600', '#FFCC66', '#009900'],
      keyArr: [],
      pamentData: [],
      ecartLine: null,
      todayPull: [],
      todaySuccess: [],
      yesterdayPull: [],
      yesterdaySuccess: [],
      lastWeekPull: [],
      lastWeekSuccess: [],
      series: [],
      intervalLine: {
        startTime: 0,
        endTime: 8.3
      },
      timer: null,
      nowhm: '',
      channlList: []
    };
  },
  mounted: function mounted() {
    this.$refs.echart.style.height = this.$refs.lineBox.clientHeight - this.$refs.lineTitle.clientHeight + 'px';
    this.initEchart();
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var i, j, str, time, timelist, lastTime, hour, minute, percentage;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            for (i = 0; i < 24; i++) {
              for (j = 0; j < 60; j++) {
                str = (i > 9 ? i : '0' + i) + ':' + (j > 9 ? j : '0' + j);
                _this.keyArr.push(str);
              }
            }
            time = formatTimeToStr(new Date(), 'hh:mm');
            timelist = time.split(':');
            lastTime = '';
            if (Number(timelist[1]) + 30 >= 60) {
              hour = Number(timelist[0]) + 1;
              minute = (Number(timelist[1]) + 30) % 60;
              if (hour >= 24) {
                hour = 0;
              }
              lastTime = (hour < 10 ? '0' + hour : hour) + ':' + (minute < 10 ? '0' + minute : minute);
            } else {
              lastTime = timelist[0] + ':' + (Number(timelist[1]) + 30);
            }
            if (_this.keyArr.indexOf('02:00') < _this.keyArr.indexOf(lastTime)) {
              percentage = _this.keyArr.indexOf(lastTime) / _this.keyArr.length * 100;
              _this.intervalLine.endTime = percentage;
              _this.intervalLine.startTime = percentage - 8.3;
            }
            _context.next = 1;
            return _this.getPayLine();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  destroyed: function destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    initEchart: function initEchart() {
      this.ecartLine = echarts.init(this.$refs.echart);
    },
    setOptinon: function setOptinon() {
      this.ecartLine.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: this.lineColor[3]
            }
          }
        },
        legend: {
          data: this.lineName,
          type: 'scroll',
          orient: 'horizontal'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          boundaryGap: false,
          data: this.keyArr
        }],
        yAxis: [{
          type: 'value'
        }],
        dataZoom: [{
          id: 'dataZoomX',
          type: 'inside',
          filterMode: 'none',
          start: this.intervalLine.startTime,
          end: this.intervalLine.endTime
        }],
        series: [{
          color: this.lineColor[2],
          name: this.$t('PaymentTrends.PullupLastWeek'),
          type: 'line',
          showSymbol: false,
          lineStyle: {
            type: 'dotted'
          },
          data: this.lastWeekPull
        }, {
          color: this.lineColor[2],
          name: this.$t('PaymentTrends.SuccessfulLastWeek'),
          type: 'line',
          showSymbol: false,
          data: this.lastWeekSuccess
        }, {
          color: this.lineColor[1],
          name: this.$t('PaymentTrends.PullupYesterday'),
          type: 'line',
          showSymbol: false,
          lineStyle: {
            type: 'dotted'
          },
          data: this.yesterdayPull
        }, {
          color: this.lineColor[1],
          name: this.$t('PaymentTrends.SuccessfulYesterday'),
          type: 'line',
          showSymbol: false,
          data: this.yesterdaySuccess
        }, {
          color: this.lineColor[0],
          name: this.$t('PaymentTrends.PullupToday'),
          type: 'line',
          showSymbol: false,
          data: this.todayPull,
          lineStyle: {
            type: 'dotted'
          }
        }, {
          color: this.lineColor[0],
          name: this.$t('PaymentTrends.SuccessfulToday'),
          type: 'line',
          showSymbol: false,
          data: this.todaySuccess
        }].concat(_toConsumableArray(this.series))
      });
    },
    refreshdata: function refreshdata() {
      var _this2 = this;
      this.timer = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var startTime, res, objKeyList, i;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              startTime = parseInt(new Date().getTime() - 1800000 / 1000);
              _this2.nowhm = formatTimeToStr(startTime * 1000, 'hh:mm');
              _context2.next = 1;
              return showPayLineData({
                startTime: startTime
              });
            case 1:
              res = _context2.sent;
              if (!(res.code === 0)) {
                _context2.next = 5;
                break;
              }
              objKeyList = Object.keys(res.data.list);
              i = 0;
            case 2:
              if (!(i < objKeyList.length)) {
                _context2.next = 4;
                break;
              }
              if (!(objKeyList[i] === GetDateStr(0))) {
                _context2.next = 3;
                break;
              }
              _this2.todayLastData(res.data.list[objKeyList[i]]);
              return _context2.abrupt("continue", 4);
            case 3:
              i++;
              _context2.next = 2;
              break;
            case 4:
              _this2.ecartLine.setOption({
                series: [{
                  name: _this2.$t('PaymentTrends.PullupLastWeek'),
                  data: _this2.lastWeekPull
                }, {
                  name: _this2.$t('PaymentTrends.SuccessfulLastWeek'),
                  data: _this2.lastWeekSuccess
                }, {
                  name: _this2.$t('PaymentTrends.PullupYesterday'),
                  data: _this2.yesterdayPull
                }, {
                  name: _this2.$t('PaymentTrends.SuccessfulYesterday'),
                  data: _this2.yesterdaySuccess
                }, {
                  name: _this2.$t('PaymentTrends.PullupToday'),
                  data: _this2.todayPull
                }, {
                  name: _this2.$t('PaymentTrends.SuccessfulToday'),
                  data: _this2.todaySuccess
                }].concat(_toConsumableArray(_this2.series))
              });
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      })), 60000);
    },
    getPayLine: function getPayLine() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 1;
              return showPayLineData({
                startTime: 0
              });
            case 1:
              res = _context3.sent;
              if (res.code === 0) {
                _this3.formatData(res.data.list);
                _this3.setOptinon();
                _this3.refreshdata();
              }
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    formatData: function formatData(obj) {
      var objKeyList = Object.keys(obj);
      for (var i = 0; i < objKeyList.length; i++) {
        if (objKeyList[i] === GetDateStr(0)) {
          this.todayLastData(obj[objKeyList[i]]);
        } else if (objKeyList[i] === GetDateStr(-1)) {
          if (JSON.stringify(obj[objKeyList[i]]) !== '{}') {
            var objData = this.lineData(obj[objKeyList[i]]['-1']);
            this.yesterdaySuccess = this.benefit(objData.successList);
            this.yesterdayPull = this.benefit(objData.pullList);
          }
        } else if (objKeyList[i] === GetDateStr(-7)) {
          if (JSON.stringify(obj[objKeyList[i]]) !== '{}') {
            var _objData = this.lineData(obj[objKeyList[i]]['-1']);
            this.lastWeekSuccess = this.benefit(_objData.successList);
            this.lastWeekPull = this.benefit(_objData.pullList);
          }
        }
      }
    },
    todayLastData: function todayLastData(obj) {
      if (JSON.stringify(obj) !== '{}') {
        var channlindex = 0;
        var objKey = Object.keys(obj);
        for (var i = 0; i < objKey.length; i++) {
          if (objKey[i] === '-1') {
            for (var j = 0; j < obj[objKey[i]].length; j++) {
              var keyObj = this.dataHandle(obj[objKey[i]][j]);
              this.todayPull[keyObj.index] = keyObj.pullUpTimes;
              this.todaySuccess[keyObj.index] = keyObj.notifyTimes;
            }
          } else {
            var nameStr = '';
            var pullList = [];
            var successList = [];
            for (var _j = 0; _j < obj[objKey[i]].length; _j++) {
              var _keyObj = this.dataHandle(obj[objKey[i]][_j]);
              if (_j === obj[objKey[i]].length - 1) {
                nameStr = _keyObj.channelStr;
              }
              if (this.lineName.indexOf(this.$t('PaymentTrends.Pullup', {
                channel: _keyObj.channelStr
              })) < 0) {
                this.channlList.push(_keyObj.channelStr);
                this.lineName.push(this.$t('PaymentTrends.Pullup', {
                  channel: _keyObj.channelStr
                }));
                this.lineName.push(this.$t('PaymentTrends.Successful', {
                  channel: _keyObj.channelStr
                }));
                var colorLine = null;
                if (this.channlList.length < 4) {
                  colorLine = this.lineColor[this.channlList.length + 3];
                } else {
                  colorLine = this.getColor();
                  while (this.lineColor.indexOf(colorLine) >= 0) {
                    colorLine = this.getColor();
                  }
                }
                this.lineColor.push(colorLine);
                this.series.push({
                  name: this.$t('PaymentTrends.Pullup', {
                    channel: _keyObj.channelStr
                  }),
                  color: colorLine,
                  type: 'line',
                  showSymbol: false,
                  lineStyle: {
                    type: 'dotted'
                  }
                });
                this.series.push({
                  name: this.$t('PaymentTrends.Successful', {
                    channel: _keyObj.channelStr
                  }),
                  color: colorLine,
                  type: 'line',
                  showSymbol: false
                });
              }
              pullList[_keyObj.index] = _keyObj.pullUpTimes;
              successList[_keyObj.index] = _keyObj.notifyTimes;
            }
            this.seriesData(this.benefit(pullList), this.benefit(successList), channlindex * 2);
            channlindex = channlindex + 1;
          }
        }
        this.todayPull = this.benefit(this.todayPull);
        this.todaySuccess = this.benefit(this.todaySuccess);
      }
    },
    dataHandle: function dataHandle(obj) {
      var index = this.keyArr.indexOf(formatTimeToStr(obj.timeMinute * 1000, 'hh:mm'));
      var pullUpTimes = obj.pullUpTimes;
      var notifyTimes = obj.notifyTimes;
      var channelStr = obj.channelStr;
      return {
        index: index,
        pullUpTimes: pullUpTimes,
        notifyTimes: notifyTimes,
        channelStr: channelStr
      };
    },
    seriesData: function seriesData(pullList, successList, idx) {
      this.series[idx]['data'] = pullList;
      this.series[idx + 1]['data'] = successList;
    },
    benefit: function benefit(list) {
      var i = 0;
      if (this.nowhm) {
        i = this.keyArr.indexOf(this.nowhm);
      }
      for (i; i < list.length; i++) {
        if (!list[i] && list[i] !== 0) {
          list[i] = 0;
        }
      }
      return list;
    },
    lineData: function lineData(list) {
      var pullList = [];
      var successList = [];
      for (var i = 0; i < list.length; i++) {
        var keyObj = this.dataHandle(list[i]);
        pullList[keyObj.index] = keyObj.pullUpTimes;
        successList[keyObj.index] = keyObj.notifyTimes;
      }
      return {
        pullList: pullList,
        successList: successList
      };
    },
    getColor: function getColor() {
      var i = 0;
      var str = '#';
      var random = 0;
      var aryNum = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F'];
      for (i = 0; i < 6; i++) {
        random = parseInt(Math.random() * 16);
        str += aryNum[random];
      }
      return str;
    }
  }
};